/*
 * @license
 * Copyright© Celligence International, LLC - 2024
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import { MediaCarousel } from "media-logo-caraousel";
import "./NewLogo.css";
import { Container } from "react-bootstrap";

const MediaCarouselNew = () => {
  return (
    <div >
     
    <MediaCarousel jsonUrl={process.env.REACT_APP_HOTEL_LOGOCAROUSEL} />

    </div>
  );
};

export default MediaCarouselNew;